module.exports = __webpack_public_path__ + "static/media/searchAdviser.049b4ec3.gif";